import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "yellowTips" }, " 当前操作场景，暂无法实现获取正确的数据操作前内容，如有疑问，请找开发协助排查！ ", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, "当前场景可能是以下任意1种场景：", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "1. 列表数据的批量操作：可针对多条列表数据操作", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, "2. 表单页面操作：有多tab页，且不符合以下内容的场景", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, "- 所有tab页的操作1个接口处理&传所有tab更新内容", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, "- 1个tab页1个接口处理", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "cursor-pointer text-blue-500" }, " 点击，查看场景说明 ", -1)
const _hoisted_8 = { class: "mt-4" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h3", { class: "font-medium mb-2 text-sm" }, " 当前操作内容： ", -1)
const _hoisted_10 = { class: "border border-gray-300 p-2 rounded" }

import { type LogInfo } from '../type'

import {
  Tooltip,
} from 'ant-design-vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'diffOne',
  props: {
    bizService: {},
    curMenuName: {},
    errorMsg: {},
    menuId: {},
    menuName: {},
    needDiff: {},
    opTime: {},
    opUser: {},
    userName: {},
    operation: {},
    operationBody: {},
    operationType: {},
    originSys: {},
    preOperationBody: {},
    successFlg: {},
    uniValue: {}
  },
  setup(__props: any) {

const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_unref(Tooltip), { trigger: "click" }, {
      title: _withCtx(() => [
        _hoisted_2,
        _hoisted_3,
        _hoisted_4,
        _hoisted_5,
        _hoisted_6
      ]),
      default: _withCtx(() => [
        _hoisted_7
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_8, [
      _hoisted_9,
      _createElementVNode("div", _hoisted_10, _toDisplayString(props.operationBody), 1)
    ])
  ], 64))
}
}

})